<template>
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-4 d-none d-sm-block d-xs-block">
                <router-link :to="`/articles/${article.route}`"><img :src="article.stub_img" class="card-img stub-img"></router-link>
            </div>
            <div class="col-md-8">
                <div class="card-body">
                    <h5 class="card-title"><router-link :to="`/articles/${article.route}`">{{article.title}}</router-link></h5>
                    <p class="card-text">{{article.summary}}</p>
                    <p class="card-text"><small class="text-muted">{{article.date}}</small></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        article: Object
    },
    methods:{
    }
}
</script>

<style>
.stub-img {
    max-width: 100%;
    height:100%;
}
</style>